/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Pit3_TInputs */

const en_to_yaml_pit3_t = /** @type {(inputs: To_Yaml_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments cannot survive a round trip through JSON`)
};

const ko_to_yaml_pit3_t = /** @type {(inputs: To_Yaml_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주석은 JSON을 거치는 왕복을 살아남을 수 없습니다`)
};

const ja_to_yaml_pit3_t = /** @type {(inputs: To_Yaml_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントは JSON を経る往復を生き残れません`)
};

/**
* | output |
* | --- |
* | "Comments cannot survive a round trip through JSON" |
*
* @param {To_Yaml_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_pit3_t = /** @type {((inputs?: To_Yaml_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_pit3_t(inputs)
	if (locale === "ko") return ko_to_yaml_pit3_t(inputs)
	return ja_to_yaml_pit3_t(inputs)
});